import UserModalHeader from '../../../../Component/UI/UserModalHeader';
import ExpandableNotice from "../../../../Component/UI/ExpandableNotice";
/* eslint-disable react/jsx-pascal-case */
import ContentState from "../../../../Component/UI/ContentState";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import url from "../../../../Component/server";

import moment from "moment";
import api from "../../../../Component/axios_Interceptor/api";

interface Notice_Modal_Props {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  seq: number;
}

type data_type = {
  seq: number;
  live_seq: number;
  type: string;
  title: string;
  content: string;
  crt_dt: string;
}[];

const Notice_Modal = (props: Notice_Modal_Props) => {
  const { visible, handleModal } = props;

  const [data, set_Data] = useState<data_type>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const requestRef = useRef(0);

  const get_live_notice = () => {
    const request = ++requestRef.current;
    setLoading(true);
    setError("");
    set_Data([]);
    api
      .get(url.Communication_url.get_live_notice, {
        params: {
          seq: props.seq,
          type: "rn",
        },
      })
      .then(function (response) {
        if (request !== requestRef.current) return;
        if (!Array.isArray(response.data)) throw new Error("Invalid notice response");
        set_Data(response.data);
      })
      .catch(function (error) {
        if (request !== requestRef.current) return;
        setError("공지사항을 불러오지 못했습니다. 다시 시도해주세요.");
      }).finally(() => {
        if (request === requestRef.current) setLoading(false);
      });
  };

  useEffect(() => {
    if (visible) get_live_notice();
    return () => { requestRef.current += 1; };
  }, [visible, props.seq]);

  const closeModal = () => {
    handleModal(false);
  };

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no"
      onClick={event => { if (event.target === event.currentTarget) closeModal(); }}>
      <ModalBox $isOpen={visible} role="dialog" aria-modal="true" aria-label="공지사항" onClick={(e) => e.stopPropagation()}>
        <UserModalHeader title="공지사항" onClose={closeModal} />
        <Content_Box>
          {loading ? <ContentState compact kind="loading" icon="document" title="공지사항을 불러오고 있습니다." />
          : error ? <ContentState compact kind="error" icon="document" title={error} action={{ label: "다시 시도", onClick: get_live_notice }} />
          : data.length > 0 ? (
            data.map((item) => {
              return (
                <Notice_Box key={item.seq}>
                  <div className="title">{item.title}</div>
                  <br />
                  <ExpandableNotice content={item.content} />
                  <br />
                  <div className="date">
                    {moment(item.crt_dt).format("YYYY.MM.DD hh:mm:ss")}
                  </div>
                </Notice_Box>
              );
            })
          ) : (
            <ContentState compact icon="document" title="공지가 없습니다" description="새로운 공지사항이 등록되면 이곳에서 확인할 수 있어요." />
          )}
          <br />
          <br />
          <br />
          <br />
        </Content_Box>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Notice_Modal;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: absolute;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;

const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  height: 55%;
  background-color: var(--user-surface);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  color: var(--user-text);
  display: flex;
  flex-direction: column;
`;

const Content_Box = styled.div`
  min-height: 0;
  overflow-x: hidden;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 0px 16px;
  display: flex;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 16px;

  /* 스크롤바 없애기 */
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Notice_Box = styled.div`
  box-sizing: border-box;
  min-width: 0;
  flex-shrink: 0;
  overflow-wrap: anywhere;
  width: 100%;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: var(--user-border);
  padding: 30px 0px;
  line-height: 1.5;
  div.title {
    font-family: var(--font-Pretendard-SemiBold);
  }
  div.date {
    line-height: 1.5;
    font-size: 14px;
    color: var(--user-text-muted);
  }
`;
